export const isVerified = [
  { value: null, text: 'Все' },
  { value: 1, text: 'Подтвержденные' },
  { value: 0, text: 'Не подтвержденные' }
]
